import { isPlatformBrowser } from '@angular/common'
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject,
  PLATFORM_ID,
  ChangeDetectorRef,
  Injectable,
  ViewChild,
  ElementRef,
  NO_ERRORS_SCHEMA,
} from '@angular/core'
import { NGXLogger } from 'ngx-logger'
import { transformLoanAmountWithCommas } from 'src/app/core/helpers/fields-utils'
import { ApiService } from 'src/app/core/services/api.service'
import { DentistService } from 'src/app/core/services/dentist.service'
import { OfferInfo } from '../../../../core/helpers/interfaces'
import { ModalPopupsService } from '../modal-popups.service'
import { scrollModalToTop } from '../options-utils/modal-shared'
@Injectable({
  providedIn: 'any',
})
@Component({
    selector: 'app-modal-options-loan-select',
    templateUrl: './modal-options-loan-select.component.html',
    styleUrls: ['./modal-options-loan-select.component.scss'],
    standalone: false
   // schemas:[NO_ERRORS_SCHEMA]
})
export class ModalOptionsLoanSelectComponent implements OnInit {
  @Input() loanAmount = 0
  @Input() approvedLoanAmount = '2,500'
  @Input() maxApprovedLoanAmount = ''
  @Input() offers
  // : OfferInfo[] = []
  @Input() mobileNumber = ''
  @Input() breakpoints: any = {}
  @Input() loanAcctId: any = null
  @Input() isPartialApproved: any = false
  @Output() selectedOffer: EventEmitter<OfferInfo> = new EventEmitter()
  @Output() toggleLoader: EventEmitter<any> = new EventEmitter()
  public text: string
  public width: number
  showHeaderRequestedText = true
  offersData
  showAmountError = false
  amountErrorType: string
  showEnterAmount = false
  showRescoreLoader: boolean = false
  showCarouselBlocker: boolean = false
  transformLoanAmountWithCommas = transformLoanAmountWithCommas

  constructor(
    public dentist: DentistService,
    public logger: NGXLogger,
    private cdr: ChangeDetectorRef,
    private _api: ApiService,
    private modalPopups: ModalPopupsService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit(): void {
    let dat = this.dentist.loanInfo
    if (dat && dat.length) {
      this.offersData = this.mapLoanOptions(dat.options, dat.noAutoPayLoanOptions)
    } else {
      this.offersData = this.mapLoanOptions(this.offers.options, this.offers.noAutoPayLoanOptions)
      this.dentist.loanInfo = this.offers
    }
    // this.dentist.loanInfo.requestedAmount = 2750
    if (!this.dentist.loanInfo.requestedAmount || this.dentist.loanInfo.nextStep == "Pre_LO_Max_Approved") {
      this.showEnterAmount = true
      if(this.dentist.loanInfo.nextStep == "Pre_LO_Max_Approved" && this.dentist.loanInfo.requestedAmount){
        this.loanAmount = this.dentist.loanInfo.approvedLoanAmount
        this.width = (this.loanAmount + ' ').length * 0.6
      }
    }
    // this.fixedLoanAmount = this.loanAmount
    this.cdr.detectChanges()
    if (isPlatformBrowser(this.platformId)) {
      scrollModalToTop()
    }
    this.logger.info('Inside loan select')
    this.logger.info('loanAmount: ' + this.loanAmount)
    setTimeout(() => {
      this.toggleLoader.emit(false)
      this.cdr.detectChanges()
    }, 300)
    this.loanAmount = this.dentist.loanInfo.requestedAmount ? this.dentist.loanInfo.approvedLoanAmount : ''
  }

  changeAmountHeader(e) {
    this.showHeaderRequestedText = e.autoPay.productSubType !== 'TRUE_ZERO' && e.autoPay.productSubType !== 'PAYINX'
    this.loanAmount = +e.autoPay.approvedAmount
  }

  onOfferSelect(e: OfferInfo) {
    this.selectedOffer.emit(e)
  }

  mapLoanOptions(options: any[], noAutoPayOptions: any[]) {
    function mapNoAutoPay(value) {
      return noAutoPayOptions.find((val) => val.autoPayMappingOptionId === value.optionId)
    }

    const concatOptionsArr: OfferInfo[] = []
    if (options) {
      options.forEach((option) => {
        concatOptionsArr.push({ noAutoPay: mapNoAutoPay(option), autoPay: option, noAutoPayState: false })
      })
    }

    return concatOptionsArr
  }
  reScoreLoamAmount(e?: any) {
    if (!e) {
      if (this.loanAmount > this.dentist.loanInfo?.maxApprovedLoanAmount) {
        this.showAmountError = true
        this.amountErrorType = 'preApproved'
        setTimeout(() => (this.showAmountError = false), 5000)
        return
      } else if (
        this.loanAmount < this.dentist.loanInfo?.minRequestedAmount &&
        this.dentist.loanInfo?.minRequestedAmount === this.modalPopups.hawaiiMinValue
      ) {
        this.showAmountError = true
        this.amountErrorType = 'lessStateAmountAfter'
        setTimeout(() => (this.showAmountError = false), 5000)
        return
      } else if (this.loanAmount < this.dentist.loanInfo?.minRequestedAmount) {
        this.showAmountError = true
        this.amountErrorType = 'minRequiredAmount'
        this.modalPopups.changeValue(this.dentist.loanInfo?.minRequestedAmount)
        setTimeout(() => (this.showAmountError = false), 5000)
        return
      }
      const body = {
        loanAccountId: this.dentist.loanInfo.loanAcctId,
        requestedAmount: this.loanAmount,
        screenIdToBeCompleted: "Pre_LO_Max_Approved" 
      }
      this.showRescoreLoader = true
      this._api.reScoreLoanAmount(body).subscribe((t) => {
        this.offersData = this.mapLoanOptions(t.data.options, t.data.noAutoPayLoanOptions)
        this.showEnterAmount = false
        this.dentist.loanInfo.requestedAmount = t.data.requestedAmount
        this.showRescoreLoader = false
      }, ()=> this.showRescoreLoader = false)
      return
    }
    if (e.target.value.replace(',', '') > this.dentist.loanInfo?.maxApprovedLoanAmount) {
      this.showAmountError = true
      this.showCarouselBlocker = true
      this.amountErrorType = 'preApproved'
      setTimeout(() => (this.showAmountError = false), 5000)
      return
    } else if (
      e.target.value.replace(',', '') < this.dentist.loanInfo?.minRequestedAmount &&
      this.dentist.loanInfo?.minRequestedAmount === this.modalPopups.hawaiiMinValue
    ) {
      this.showAmountError = true
      this.showCarouselBlocker = true
      this.amountErrorType = 'lessStateAmountAfter'
      setTimeout(() => (this.showAmountError = false), 5000)
      return
    } else if (this.loanAmount < this.dentist.loanInfo?.minRequestedAmount) {
      this.showAmountError = true
      this.showCarouselBlocker = true
      this.amountErrorType = 'minRequiredAmount'
      this.modalPopups.changeValue(this.dentist.loanInfo?.minRequestedAmount)
      setTimeout(() => (this.showAmountError = false), 5000)
      return
    }
    const body = {
      loanAccountId: this.dentist.loanInfo.loanAcctId,
      requestedAmount: +e.target.value.replace(',', ''),
    }
    this.showRescoreLoader = true
    this._api.reScoreLoanAmount(body).subscribe((t) => {
      this.offersData = this.mapLoanOptions(t.data.options, t.data.noAutoPayLoanOptions)
      this.dentist.loanInfo.requestedAmount = t.data.requestedAmount
      this.showRescoreLoader = false
      this.showCarouselBlocker = false
    }, ()=> this.showRescoreLoader = false)
  }

  resizeInput(e) {
    this.showAmountError = false
    let val = e.target.value
    // without setTimeout the width gets updated to the previous length
    setTimeout(() => {
      const minWidth = 1.25
      this.width = Math.max(val.length * 0.6, minWidth)
      //this.renderer.setStyle(this.inputBox.nativeElement, "width", `${width}px`)
      //console.error(`element width set at: ${this.inputBox.nativeElement.style.width}`)
    }, 0)
  }
}
